import { TextBlock } from '@adviser-group/aberdeen-design-system';
import { type FirmOption } from '../index';

import styles from './index.module.scss';

type Properties = {
  readonly firmOptions: FirmOption[];
  readonly selectedFirm: string;
  readonly error?: string;
  readonly className?: string;
  readonly onFirmSelect: (firmId: string) => void;
  readonly onErrorClear: () => void;
};

const FirmSelector = ({
  firmOptions,
  selectedFirm,
  error,
  className,
  onFirmSelect,
  onErrorClear,
}: Properties) => {
  if (firmOptions.length === 0) {
    return (
      <div className={styles.textBlock}>
        <TextBlock color="primary" size="small" variant="title">
          The firm you are acting on behalf of
        </TextBlock>
        <TextBlock color="secondary" size="small" variant="title">
          No firm options available.
        </TextBlock>
      </div>
    );
  }

  if (firmOptions.length === 1) {
    const onlyFirm = firmOptions[0];
    if (onlyFirm?.id && selectedFirm !== onlyFirm.id) {
      onFirmSelect(onlyFirm.id);
    }
    return (
      <div className={styles.textBlock}>
        <label htmlFor="firmSelector">
          <TextBlock color="primary" size="static-extra-small" variant="title">
            The firm you are acting on behalf of
          </TextBlock>
        </label>
        <TextBlock color="secondary" size="static-extra-small" variant="title">
          We will use your current user profile on Aberdeen Wrap
        </TextBlock>
        <div className={styles.selectedFirmBox}>{onlyFirm?.name}</div>
      </div>
    );
  }

  return (
    <div className={styles.textBlock}>
      <label htmlFor="firmSelector">
        <TextBlock color="primary" size="static-extra-small" variant="title">
          The firm you are acting on behalf of
        </TextBlock>
      </label>
      <TextBlock color="secondary" size="static-extra-small" variant="title">
        We will use your current user profile on Aberdeen Wrap
      </TextBlock>

      {error && <div className={styles.error}>{error}</div>}

      <select
        id="firmSelector"
        className={styles.select}
        value={selectedFirm}
        onChange={(event) => {
          onFirmSelect(event.target.value);
          if (error) {
            onErrorClear();
          }
        }}
      >
        <option value="">Select a firm</option>
        {firmOptions.map((option) => (
          <option key={option.id} value={option.id}>
            {option.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default FirmSelector;
